<nb-list>
  <nb-list-item *ngFor="let itemL of exercise.exQuizzes; let i = index">
    <div>
      <button
        nbButton
        shape="round"
        outline
        size="tiny"
        status="info"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="editExQuiz(itemL)"
      >
        <nb-icon icon="edit-2-outline"></nb-icon>
      </button>

      <a class="link" (click)="testExQuiz(itemL)">
        <nb-icon icon="question-mark-outline"></nb-icon>
        <span> Câu {{ i + 1 }}: {{ itemL.quizTitle }}</span>
      </a>
    </div>

    <button
      nbButton
      shape="round"
      ghost
      size="tiny"
      status="danger"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      (click)="deleteExQuiz(itemL)"
    >
      <nb-icon icon="trash-2-outline"></nb-icon>
    </button>
  </nb-list-item>

  <nb-list-item>
    <nb-actions size="small">
      <nb-action (click)="createExQuiz()">
        <nb-icon class="action-icon" icon="plus-circle-outline"></nb-icon>
        <span class="text-link">Tạo mới câu hỏi</span>
      </nb-action>
      <nb-action (click)="onLinkQuiz()">
        <nb-icon class="action-icon" icon="file-add-outline"></nb-icon>
        <span class="text-link">Chọn từ kho câu hỏi</span>
      </nb-action>
    </nb-actions>
  </nb-list-item>
</nb-list>
